import React, { Component } from 'react';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';

export default class Bancassurance extends Component{

	constructor(props){
		super(props);

		this.state = {};
	}

	render(){
		const menuItems = [
			{ id: "broker-agencies", name: "All Banks", active: true },
            { id: "broker-admins", name: "All Bank Admins" },
            { id: "add-bank", name: "Add Bank" },
            { id: "add-bank-admin", name: "Add Bank Admin" }
		]

		return(
			<Page isAdminPage={ true } pageTitle="Bancassurance">
				<div className="clearfix">
					<TabHolder menuItems={ menuItems }>
						
						<Tab menuId={ menuItems[0].id } isActive={ true }>
                            <DataTable 
                                tableId="banks-table"
                                columnTitles={ ["Name", "Postal Address", "Email", "Helpline", "Credit Approved", 
                                    "Credit Line (KES)", "Credit Balance (KES)", "Credit Period (Days)", "Action"] }>

                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            
                            </DataTable>
						</Tab>

                        <Tab menuId={ menuItems[1].id }>
                            <DataTable 
                                tableId="admins-table"
                                columnTitles={ ["Name", "Bank", "Postal Address", "Email", "Helpline", "Actions"] }>
                            
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            </DataTable>
						</Tab>

                        <Tab menuId={ menuItems[2].id }>
                            <div className="col-md-6">
                                <form className="form-horizontal" novalidate>
                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Bank Name: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="name" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Insurer Branch:<span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <select className="form-control" name="insurer_branch" required>
                                                <option value="">-- Select Insurer Branch --</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Postal Address: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="postal_address" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Tax Idenitification Number: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="tin" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Email Address: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="email" name="email" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Phone Number: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="tel" name="phone" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Minimum Premium: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" name="minimum_premium" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Credit Limit: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" name="credit_line" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Credit Period: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input className="form-control" name="credit_period" require />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-md-8 col-md-offset-4">
                                            <button type="submit" className="btn btn-success">
                                                <i className="icon ion-checkmark"></i> Create Bank
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
						</Tab>

						<Tab menuId={ menuItems[3].id }>
                            <div className="col-md-6">
                                <form className="form-horizontal" novalidate>
                                    <div className="form-group">
                                        <label className="col-md-4 control-label">First Name: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="first_name" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Last Name: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="last_name" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Other Names:</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Username: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="username" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Email: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="email" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Phone Number: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="phone" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Postal Address: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" name="postal_address" className="form-control" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-4 control-label">Bank: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <select className="form-control" name="bank" required>
                                                <option value="">-- Select Bank --</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-md-8 col-md-offset-4">
                                            <button type="submit" className="btn btn-success">
                                                <i className="icon ion-checkmark"></i> Create Bank Admin
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
						</Tab>
					</TabHolder>
				</div>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/Bancassurance.jsx